import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EditeurTournee } from '../tournee/EditeurTournee';
import { ModeTournee } from '../tournee/ModeTournee';

const rechercheSchema = z.object({
  mode: z.enum(['route']).optional().catch(undefined),
});

export const Route = createFileRoute('/tournees/$id')({
  validateSearch: rechercheSchema,
  component: function PageTournee() {
    const { id } = Route.useParams();
    const { mode } = Route.useSearch();
    return mode === 'route' ? <ModeTournee id={id} /> : <EditeurTournee id={id} />;
  },
});
